import { EventBlocks, EventBlocksType, EventUniqueBlocks } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";

interface Props {
  type: EventBlocksType;
  id: string;
}

export const getEventBlockPathId = ({ type, id }: Props): string => {
  switch (type) {
    case EventBlocks.accommodation:
      return API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(id);
    case EventBlocks.guestlist:
      return API_ENDPOINTS.EVENT_GUESTLIST_BLOCK(id);
    case EventBlocks.infoBlock:
      return API_ENDPOINTS.EVENT_INFO_BLOCK(id);
    case EventBlocks.schedule:
      return API_ENDPOINTS.EVENT_SCHEDULE_BLOCK(id);
    case EventBlocks.travel:
      return API_ENDPOINTS.EVENT_TRAVEL_BLOCK(id);
    case EventUniqueBlocks.people:
      return API_ENDPOINTS.EVENT_PEOPLE_BLOCK(id);
    case EventUniqueBlocks.venue:
      return API_ENDPOINTS.EVENT_VENUE_BLOCK(id);
    default:
      return "";
  }
};
